<template>
    <CompassToggleButtonGroup
        :modelValue="activeFilter"
        exclusive
        @update:modelValue="handleChange"
    >
        <CompassToggleButton
            v-for="(label, value) in filtersButton"
            :key="value"
            :value="value"
            :label="label"
        />
    </CompassToggleButtonGroup>
</template>
<script>
export default {
    props: {
        activeFilter: {
            type: Array,
            required: true,
        },
        overviewType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            filtersButton: {
                all: this.$l10n.__('Tous'),
                third: this.$l10n.__('Société'),
                opportunity: this.$l10n.__('Opportunité'),
                people: this.$l10n.__('Contact'),
                estimate: this.$l10n.__('Devis'),
                invoice: this.$l10n.__('Facture'),
            },
        };
    },
    created() {
        if (this.overviewType !== 'third') {
            delete this.filtersButton.third;
        } else {
            this.filtersButton.third = this.$store.getters.identity.isCorporation
                ? this.$l10n.__('Société')
                : this.$l10n.__('Particulier');
        }
    },
    methods: {
        handleChange(value) {
            if (value !== '') {
                this.$emit('filterUpdate', [value]);
            }
        },
    },
};
</script>
